import { Component, OnInit } from '@angular/core';
import { FspDocumentsGridDataService } from './fsp-documents-grid-data.service';
import { FspDocumentsRequestGridDto } from './fsp-documents-grid-data-model';
import {
  apDocumentsRequestGridColumns,
  getFspDocumentsRequestGridToolbarItems,
} from './fsp-documents-grid-model';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { filter, takeWhile, tap } from 'rxjs';
import { FreeServicesRequestListGridDataService } from '../free-services-request-list-grid/free-services-request-list-grid-data.service';
import { GkKendoGridComponent } from '../../gk-kendo';

@Component({
  selector: 'app-fsp-documents-grid',
  templateUrl:
    '../../../../../../libs/gk-modules/src/lib/gk-kendo/gk-kendo-grid/gk-kendo-grid.component.html',
  standalone: false,
})
export class FspDocumentsGridComponent
  extends GkKendoGridComponent<FspDocumentsRequestGridDto>
  implements OnInit
{
  constructor(
    private fspDocumentsGridDataService: FspDocumentsGridDataService,
    private requestListGridDataService: FreeServicesRequestListGridDataService,
  ) {
    super(fspDocumentsGridDataService);
  }

  override topGridToolbarItems = getFspDocumentsRequestGridToolbarItems();
  override columns = apDocumentsRequestGridColumns;
  override selectable: SelectableSettings = {
    enabled: true,
    mode: 'single',
  };
  override sortable = true;

  ngOnInit(): void {
    this.subscribeRequestListUuidSelected();
  }

  subscribeRequestListUuidSelected(): void {
    this.requestListGridDataService.$selection
      .pipe(
        takeWhile(() => this.isAlive),
        tap(() => {
          this.fspDocumentsGridDataService.clearGridData();
        }),
        filter(Boolean),
      )
      .subscribe((request) => {
        const uuid = request.selectedRows[0].dataItem.ZamowUuid;
        this.fetchDocumentationsGridData(uuid);
      });
  }

  fetchDocumentationsGridData(uuid: string): void {
    this.fspDocumentsGridDataService.queryByUrlParams(
      `/api/interesant/zamowienia/${uuid}/dokwych`,
    );
  }
}
